import { useState, useEffect } from 'react';
import { ScrollText, RefreshCw, Download } from 'lucide-react';
import { supabase } from '../integrations/supabase/client';
import { exportToCSV } from '../utils/export';

export function Logs() {
 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [logs, setLogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const { data } = await supabase
        .from('audit_logs')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(100);
      setLogs(data || []);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const actionColors: Record<string, string> = {
    create: 'bg-emerald-500/20 text-emerald-400',
    update: 'bg-blue-500/20 text-blue-400',
    delete: 'bg-red-500/20 text-red-400',
    login: 'bg-violet-500/20 text-violet-400',
    logout: 'bg-slate-500/20 text-slate-400',
  };

  const filteredLogs = filter === 'all'
    ? logs
    : logs.filter((l) => l.action?.toLowerCase().includes(filter));

  const handleExportLogs = () => {
    exportToCSV(filteredLogs, 'audit_logs', [
      { key: 'id', label: 'ID' },
      { key: 'action', label: 'Ação' },
      { key: 'user_id', label: 'Usuário' },
      { key: 'entity_type', label: 'Entidade' },
      { key: 'ip_address', label: 'IP' },
      { key: 'created_at', label: 'Data' },
    ]);
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-white mb-2">Logs de Auditoria</h1>
          <p className="text-slate-400">Histórico de ações do sistema</p>
        </div>
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={handleExportLogs}
            className="flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10 rounded-lg text-slate-300 hover:bg-white/10"
          >
            <Download className="w-4 h-4" />
            Exportar
          </button>
          <button
            onClick={fetchLogs}
            className="flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10 rounded-lg text-slate-300 hover:bg-white/10"
          >
            <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
            Atualizar
          </button>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="px-4 py-2 bg-white/5 border border-white/10 rounded-lg text-white focus:outline-none focus:border-red-500"
        >
          <option value="all">Todas as Ações</option>
          <option value="create">Criações</option>
          <option value="update">Atualizações</option>
          <option value="delete">Deleções</option>
          <option value="login">Logins</option>
        </select>
      </div>

      <div className="bg-[#0a0a0a] border border-white/10 rounded-2xl overflow-hidden">
        {loading ? (
          <div className="flex items-center justify-center py-20">
            <RefreshCw className="w-8 h-8 animate-spin text-red-500" />
          </div>
        ) : filteredLogs.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20 text-slate-400">
            <ScrollText className="w-12 h-12 mb-4 opacity-50" />
            <p>Nenhum log encontrado</p>
          </div>
        ) : (
          <table className="w-full">
            <thead>
              <tr className="border-b border-white/10">
                <th className="text-left py-4 px-6 text-xs font-medium text-slate-400 uppercase">Data/Hora</th>
                <th className="text-left py-4 px-6 text-xs font-medium text-slate-400 uppercase">Ação</th>
                <th className="text-left py-4 px-6 text-xs font-medium text-slate-400 uppercase">Entidade</th>
                <th className="text-left py-4 px-6 text-xs font-medium text-slate-400 uppercase">Usuário</th>
                <th className="text-left py-4 px-6 text-xs font-medium text-slate-400 uppercase">IP</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {filteredLogs.map((log) => (
                <tr key={log.id} className="hover:bg-white/5">
                  <td className="py-4 px-6 text-slate-400 text-sm">
                    {new Date(log.created_at).toLocaleString('pt-BR')}
                  </td>
                  <td className="py-4 px-6">
                    <span className={`px-2.5 py-1 rounded-full text-xs ${actionColors[log.action.split('_')[0]] || 'bg-slate-500/20 text-slate-400'}`}>
                      {log.action}
                    </span>
                  </td>
                  <td className="py-4 px-6 text-white">{log.entity_type || log.resource || '—'}</td>
                  <td className="py-4 px-6 text-slate-400 font-mono text-sm">
                    {log.user_id?.slice(0, 8)}...
                  </td>
                  <td className="py-4 px-6 text-slate-400 text-sm">{log.ip_address || 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

